/**
 * LINKURIOUS CONFIDENTIAL
 * Copyright Linkurious SAS 2012 - 2018
 *
 * Created by andrebarata on 2018-08-22.
 */


'use strict';
import { NgModule } from '@angular/core';
import { KeyboardNavigationDirective } from './directive';

@NgModule({
  imports     : [],
  declarations: [KeyboardNavigationDirective],
  exports     : [KeyboardNavigationDirective]
})
export class KeyboardNavigation {
}
